module.exports = __webpack_public_path__ + "img/Picture11.83c1c28c.jpg";